import React, { useEffect, useRef, useState } from 'react';

const House = () => {
  const canvasRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audio] = useState(new Audio('https://listen.openstream.co/7442/audio'));
  const [nowPlaying, setNowPlaying] = useState('Now Playing: Loading current track...');
  const [history, setHistory] = useState([]);

  useEffect(() => {
    audio.crossOrigin = "anonymous";
    fetchSongData();
    const interval = setInterval(fetchSongData, 10000);
    return () => clearInterval(interval);
  }, []);

  const togglePlay = () => {
    const canvas = canvasRef.current;
    if (!audio.context) {
      initVisualizer(canvas);
    }

    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  const initVisualizer = (canvas) => {
    const ctx = canvas.getContext("2d");
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const analyser = audioContext.createAnalyser();
    const source = audioContext.createMediaElementSource(audio);
    source.connect(analyser);
    analyser.connect(audioContext.destination);
    analyser.fftSize = 256;

    const bufferLength = analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    function draw() {
      requestAnimationFrame(draw);
      analyser.getByteFrequencyData(dataArray);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const barWidth = (canvas.width / bufferLength) * 2;
      let x = 0;
      ctx.fillStyle = "#04EFA0";
      for (let i = 0; i < bufferLength; i++) {
        let barHeight = dataArray[i] / 2;
        ctx.fillRect(x, canvas.height - barHeight, barWidth, barHeight);
        x += barWidth + 2;
      }
    }
    draw();
  };

  const fetchSongData = async () => {
    try {
      const response = await fetch("https://cloud.cuedj.live:4435/api/nowplaying/2");
      const data = await response.json();
      setNowPlaying(`Now Playing: ${data.now_playing.song.artist} - ${data.now_playing.song.title}`);
      setHistory(data.song_history.slice(0, 5));
    } catch (err) {
      console.error("Failed to fetch song data:", err);
    }
  };

  return (
    <div className="player-container">
      <div className="now-playing">{nowPlaying}</div>
      <button className="big-play-button" onClick={togglePlay}>
        <img
          id="playPauseIcon"
          src={isPlaying
            ? "https://cuedj.live/wp-content/uploads/2025/02/pause.png"
            : "https://cuedj.live/wp-content/uploads/2025/02/play.png"}
          alt="Play/Pause"
        />
      </button>
      <canvas id="visualizer" ref={canvasRef} style={{ display: isPlaying ? 'block' : 'none' }} width="800" height="200"></canvas>
      <div className="song-history">
        <h3>Last 5 Songs Played</h3>
        <ul>
          {history.map((song, index) => (
            <li key={index}>{song.song.artist} - {song.song.title}</li>
          ))}
        </ul>
      </div>

      {/* Custom styles inline or import your CSS file */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap');
        .player-container {
          display: flex; flex-direction: column; align-items: center;
          width: 100%; max-width: 800px; margin: auto;
          padding: 40px 20px; text-align: center; font-family: 'Montserrat', sans-serif;
        }
        .now-playing { font-size: 18px; font-weight: 600; color: white; margin-bottom: 20px; }
        .big-play-button { background: none; border: none; cursor: pointer; }
        .big-play-button img { width: 120px; height: 120px; }
        canvas { background: transparent; margin-top: 20px; }
        .song-history { color: white; margin-top: 20px; }
        .song-history ul { list-style: none; padding: 0; }
        .song-history li { font-size: 14px; margin: 8px 0; }
        @media (max-width: 768px) {
          .big-play-button img { width: 100px; height: 100px; }
          canvas { width: 90%; height: 150px; }
        }
      `}</style>
    </div>
  );
};

export default House;
